import { useState } from 'react';
import BannerImageURL from '../../logo/banner.png';
import { useAuth } from '../../context/AuthContext';

/**
 * Port of `utilComponents/banner.jsx`.
 *
 * `showBanner` and `bannerLink` came from the bundled property.json; they now arrive on
 * the runtime config. Both are false/empty in all five environment files today, so this
 * renders nothing until someone turns it on in a ConfigMap — which is the point: doing
 * so no longer needs a rebuild.
 */
export function Banner({ bannerVisible }: { bannerVisible: (visible: boolean) => void }) {
  const { config } = useAuth();
  const [visible, setVisible] = useState<boolean>(config?.banner.showBanner ?? false);

  const bannerLink = config?.banner.bannerLink ?? '';

  const handleBannerClose = (): void => {
    setVisible(false);
    bannerVisible(false);
  };

  const handleBannerClick = (): void => {
    if (bannerLink && bannerLink.trim() !== '') {
      window.open(bannerLink, '_blank', 'noopener,noreferrer');
    }
  };

  const modelStyle = {
    display: visible ? 'block' : 'none',
    backgroundColor: 'rgba(0,0,0,0.8)',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  } as const;

  return (
    <div>
      <>
        <div className="ch-notif-banner">
          <div className="banner modal show" style={modelStyle}>
            <div className="banner modal-dialog modal-width">
              <div className="banner modal-content">
                <button
                  type="button"
                  className="banner btn-close"
                  onClick={handleBannerClose}
                ></button>

                <div className="bannermodal-body">
                  <img
                    src={BannerImageURL}
                    alt="CheckIn"
                    onClick={handleBannerClick}
                    style={{ cursor: bannerLink ? 'pointer' : 'default' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}
